import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addItemInsuranceEligibility = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Item Insurance Eligibility',
    body
  );
  return data;
});
export const updateItemInsuranceEligibility = catchAsync(
  async ({ body, id }) => {
    const { data } = await axiosInstance.put(
      `/api/resource/Item Insurance Eligibility/${id}`,
      body
    );
    return data;
  }
);
export const deleteItemInsuranceEligibility = catchAsync(async (id) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Item Insurance Eligibility/${id}`
  );
  return data;
});

export const getItemInsuranceEligibility = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Item Insurance Eligibility?fields=["name","eligibility_for","item_code","insurance_plan","coverage","discount","template_dn","template_dt","mode_of_approval","valid_from"]'
  );
  return data;
});
export const getItemInsuranceEligibilityById = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Item Insurance Eligibility/${id}`
  );
  return data;
});

export const getAllItems = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_items'
  );
  return data;
});
